import { useBackend } from "../../services";

export const useAuthenticatePasskey = () => {
  const { post } = useBackend();
  return async (challenge: string, authenticationResponse: any) => {
    return await post(`passkeys/authentication`, {
      challenge,
      authenticationResponse
    });
  };
};
